"use client";
import { useEffect } from "react";
import { useWindowDimension } from "@/hooks/dim-hook";

const WindowDimensions = () => {
  useWindowDimension();

  useEffect(() => {
    if (typeof document === "undefined") return;

    // `manipulation` suppresses the accidental DOUBLE-TAP zoom (the original intent here)
    // while still allowing intentional PINCH zoom — unlike the previous `pan-x pan-y`,
    // which blocked pinch too. Blocking zoom fails WCAG 1.4.4 (see getViewPort in seo.ts,
    // which no longer sets user-scalable=no / maximum-scale).
    //
    // The `gesturestart`, non-passive `wheel` and ctrl+±/0 `keydown` handlers that used to
    // live here were removed deliberately: they were three overlapping ways to block zoom,
    // and the `wheel` one was the worst offender — a non-passive listener on `document`
    // makes EVERY wheel event scroll-blocking app-wide (measured: 57% of scroll frames
    // over 22ms). `touch-action` achieves the double-tap intent at zero runtime cost.
    document.documentElement.style.touchAction = "manipulation";
    document.body.style.touchAction = "manipulation";
  }, []);

  return <></>;
};

export default WindowDimensions;
